import React from 'react';

const reactVersion = React.version || '?';

const ReactVersion = () => <>React {reactVersion}</>;

export default ReactVersion;
